import { render, staticRenderFns } from "./CopyrightServices.vue?vue&type=template&id=46f65886"
import script from "./CopyrightServices.vue?vue&type=script&lang=js"
export * from "./CopyrightServices.vue?vue&type=script&lang=js"
import style0 from "./CopyrightServices.vue?vue&type=style&index=0&id=46f65886&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports